module.exports = __webpack_public_path__ + "assets/static/png/mobsec1.25c0425d1aa054ee92fb45d16142f943.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/mobsec1.png
 ** module id = 495
 ** module chunks = 1
 **/